import { useRef, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getAvailableMergeSplitStops } from '../../../store/selectors/ui/routeDetail';
import { wrapPromise } from '../../../utils/promise';
import { splitStopActionCreators } from '../../../store/actions/ui/routeDetail/splitStop';

const useSplitStopModalData = () => {
  const splitStopModalRef = useRef();
  const dispatch = useDispatch();

  const dropdownListStops = useSelector(getAvailableMergeSplitStops);

  const { onApplySplit, fetchDestinationStop, hideSplitStopNotifications } =
    useMemo(
      () => bindActionCreators(splitStopActionCreators, dispatch),
      [dispatch]
    );

  const openSplitStopsModal = useCallback(
    () =>
      wrapPromise(
        splitStopModalRef.current.showModal({
          dropdownListStops,
          onApplySplit,
          fetchDestinationStop,
          hideSplitStopNotifications,
        })
      ),
    [
      dropdownListStops,
      onApplySplit,
      fetchDestinationStop,
      hideSplitStopNotifications,
    ]
  );

  return {
    splitStopModalRef,
    openSplitStopsModal,
  };
};

export default useSplitStopModalData;
